import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { UserManagementService } from '@dss-libs/shared/data-access/users';
import { filter, map, take } from 'rxjs';

export const ProfileReadyGuard: CanActivateFn = () => {
  const userProfileResource = inject(UserManagementService).userProfileResource;

  return toObservable(userProfileResource.status).pipe(
    filter((status) => status === 'resolved' || status === 'error'),
    take(1),
    map(() => userProfileResource.hasValue())
  );
};
